import React from 'react'
import styled from 'styled-components'

import { ButtonTo } from 'components/buttons/'

// const FormWrapper = styled.div`
//   padding: 0;

//   @media screen and (min-width: 500px) {
//     padding: 1.5rem;
//     padding-top: 1rem;
//   }

//   @media screen and (min-width: 768px) {
//     padding: 2rem;
//     padding-top: 1.5rem;
//   }
// `

interface Props {
  className?: string
}

const SignUpButton = (props: Props) => {
  // const [showSignUpForm, setShowSignUpForm] = React.useState(false)
  // const handleSubmit = () => {
  //   setShowSignUpForm(false)
  // }

  // const handleClick = () => setShowSignUpForm(true)

  return (
    <div className={props.className}>
      {/* <Button onClick={handleClick} primary>
        Try it for free
      </Button> */}
      <ButtonTo primary to="/sign-up/">
        Try it for free
      </ButtonTo>
      {/* <Modal
        isVisible={showSignUpForm}
        portalId="sign-up-portal"
        setIsVisible={(value) => setShowSignUpForm(value)}
      >
        <FormWrapper>
          <SignUpForm onSubmit={handleSubmit} />
        </FormWrapper>
      </Modal> */}
    </div>
  )
}

export default styled(SignUpButton)``
